import { ReactNode } from "react"

import { BaseInput, ConcreteInputProps } from "./BaseInput"
import { PasswordInput } from "./PasswordInput"
import { SearchInput } from "./SearchInput"

type TextInputProps = ConcreteInputProps & {
  type?: "text" | "email"
  leftReactNode?: ReactNode
  extraInputClasses?: Array<string>
}

const TextInput = (props: TextInputProps) => {
  return <BaseInput type={"text"} {...props} />
}

export { TextInput, SearchInput, PasswordInput }
